
export default () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large`}>
      <path d="M32.14,14.68h2.29c0.64,0,1.23-0.59,1.23-1.23V5.74c0-0.64-0.59-1.23-1.23-1.23h-2.29c-0.64,0-1.23,0.59-1.23,1.23v3.35 H17.09V5.74c0-0.64-0.59-1.23-1.23-1.23h-2.29c-0.64,0-1.23,0.59-1.23,1.23v7.71c0,0.64,0.59,1.23,1.23,1.23h2.29 c0.64,0,1.23-0.59,1.23-1.23V10.1h6.59v27.8h-6.59v-3.35c0-0.7-0.53-1.23-1.23-1.23h-2.29c-0.64,0-1.23,0.59-1.23,1.23v7.72 c0,0.64,0.59,1.23,1.23,1.23h2.29c0.64,0,1.23-0.59,1.23-1.23v-3.35h13.82v3.35c0,0.64,0.59,1.23,1.23,1.23h2.29 c0.64,0,1.23-0.59,1.23-1.23v-7.72c0-0.7-0.53-1.23-1.23-1.23h-2.29c-0.64,0-1.23,0.59-1.23,1.23v3.35h-6.23V10.1h6.23v3.35 C30.91,14.09,31.49,14.68,32.14,14.68z"/>
    </svg>
  );
}
